export enum DisplayEnum {
    CARDS = 'cards',
    SWIPPABLE_CARDS = 'swippableCards',
}
